import React from 'react';

const Footer = () => {
	const currentYear = new Date().getFullYear();
	return (
		<footer class='px-4 py-8 bg-cream'>
			<div class='container flex flex-wrap items-center justify-center mx-auto space-y-4 sm:justify-between sm:space-y-0'>
				<div class='flex flex-row pr-3 space-x-4 sm:space-x-8'>
					<ul class='flex flex-wrap items-center space-x-4 sm:space-x-8'>
						<li>
							<p>© {currentYear} Datson Tattoo. All Rights Reserved.</p>
						</li>
					</ul>
				</div>
				<ul class='flex flex-wrap pl-3 space-x-4 sm:space-x-8'>
					<li>
						<a
							rel='noopener noreferrer'
							href='https://www.instagram.com/datson.tattoos?fbclid=IwY2xjawEWuBFleHRuA2FlbQIxMAABHTuPsyFD2gCtRJGSGqzTsYfsl-VVMsNhCZLM678CEACXWdKN0031g8cYUw_aem_oXN2G5sgcAAHadw-s-g90g'>
							Instagram
						</a>
					</li>
					<li>
						<a
							rel='noopener noreferrer'
							href='https://www.facebook.com/datsontattoos'>
							Facebook
						</a>
					</li>
					<li>
						<a
							rel='noopener noreferrer'
							href='https://www.facebook.com/datsontattoos'>
							Twitter
						</a>
					</li>
				</ul>
			</div>
		</footer>
	);
};

export default Footer;
